import { all, put, takeEvery, call } from 'redux-saga/effects';
import axios from 'axios';
import { CommonConfig } from '../../../../../config/common-config';

import {
    CreateBankDetailsActionTypes,
    DeleteBankDetailsActionTypes,
    GetBankDetailsActionTypes,
    EditBankDetailsActionTypes,
} from '../actionsTypes';

function* handleCreateBankDetailsRequest(action) {
    try {
        const { params } = action.payload;
        const res = yield call(axios, '/api/auth/s-bankdetails', { method: 'post', baseURL: `${CommonConfig.dev.baseUrl}`, data: params });
        const createbankdetails = res.data;
        yield put({ type: CreateBankDetailsActionTypes.SUCCESS, payload: createbankdetails });
    } catch (e) {
        // console.warn('FAILED to handle get Employees request due to', e.message);
        //console.log('ravi', e);
        const errorMessage = e.response;
        yield put({ type: CreateBankDetailsActionTypes.FAILED, error: errorMessage });
    }
}

function* handleDeleteBankDetailsRequest(action) {
    try {
        const { params } = action.payload;
        const data = params.id;
        const res = yield call(axios, `/api/auth/s-bankdetails/${data}`, { method: 'delete', baseURL: `${CommonConfig.dev.baseUrl}` });
        const deletebankdetails = res.data;
        //console.log('deletebankdetails', res);

        yield put({ type: DeleteBankDetailsActionTypes.SUCCESS, payload: deletebankdetails });
    } catch (error) {
        // console.warn('error', error);
        yield put({ type: DeleteBankDetailsActionTypes.FAILED, error: error.message });
    }
}
function* handleGetBankDetailsRequest(action) {
    try {
        const { params } = action.payload;
        const res = yield call(axios, '/api/auth/s-bankdetails', {
            method: 'get',
            baseURL: `${CommonConfig.dev.baseUrl}`,
            headers: {
                Authorization: params,
            },
        });
        const getbankdetails = res.data;
        yield put({ type: GetBankDetailsActionTypes.SUCCESS, payload: getbankdetails });
    } catch (e) {
        yield put({ type: GetBankDetailsActionTypes.FAILED, error: e.message });
    }
}

function* handleEditBankDetailsRequest(action) {
    try {
        const { params, bearerToken } = action.payload;
        const res = yield call(axios, '/api/auth/s-bankdetails', {
            method: 'put',
            baseURL: `${CommonConfig.dev.baseUrl}`,
            data: params,
            headers: {
                Authorization: bearerToken,
            },
        });
        const editbankdetails = res.data;
        yield put({ type: EditBankDetailsActionTypes.SUCCESS, payload: editbankdetails });
    } catch (e) {
        yield put({ type: EditBankDetailsActionTypes.FAILED, error: e.message });
    }
}

function* watchCreateBankDetailsRequest() {
    yield takeEvery(CreateBankDetailsActionTypes.REQUEST, handleCreateBankDetailsRequest);
    yield takeEvery(DeleteBankDetailsActionTypes.REQUEST, handleDeleteBankDetailsRequest);
    yield takeEvery(GetBankDetailsActionTypes.REQUEST, handleGetBankDetailsRequest);
    yield takeEvery(EditBankDetailsActionTypes.REQUEST, handleEditBankDetailsRequest);
}

export function* createBankDetailsSaga() {
    yield all([watchCreateBankDetailsRequest()]);
}
